// stores/operatorProfileStore.ts
import { create } from 'zustand';
import apiClient from '../apiSetup/axiosInterceptor';

interface Operator {
  user_id: string;
  name: string;
  email: string;
  mobileNumber: string | null;
  role: string;
}

interface OperatorProfile {
  operator: Operator;
  institute_id: string;
  institute_name: string;
  branch_id: string;
  branch_name: string;
}

interface ApiResponse {
  success: boolean;
  data: OperatorProfile;
}

interface OperatorProfileState {
  profile: OperatorProfile | null;
  loading: boolean;
  error: string | null;
  fetchProfile: () => Promise<void>;
  clearError: () => void;
}

export const useOperatorProfileStore = create<OperatorProfileState>((set) => ({
  profile: null,
  loading: false,
  error: null,
  clearError: () => set({ error: null }),
  fetchProfile: async () => {
    set({ loading: true, error: null });
    try {
      const response = await apiClient.get<ApiResponse>('/v1/admin/operator-profile');
      // Access response.data.data because API wraps it in { success: true, data: {...} }
      set({ profile: response.data.data, loading: false });
    } catch (err: any) {
      const message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        'Failed to load operator profile';
      set({ error: message, loading: false });
    }
  },
}));